import type { referencesFr } from './references.fr';

type DeepStrings<T> = { [K in keyof T]: T[K] extends string ? string : DeepStrings<T[K]> };

/** English texts for references between objects (2026-11-04). Same keys as `references.fr.ts`. */
export const referencesEn: DeepStrings<typeof referencesFr> = {
  copied: 'Identifier copied',
  copyLabel: '{{kind}} {{id}} — copy the identifier',
  missing: '{{kind}} not found (deleted or outside your permissions)',
  kinds: {
    project: 'Project',
    job: 'Job',
    workflow: 'Workflow',
    jobRun: 'Run',
    workflowRun: 'Workflow run',
    identity: 'Identity',
    user: 'User',
    principal: 'User or identity',
    group: 'Group',
    role: 'Role',
    secret: 'Secret',
    application: 'API token',
    identityProvider: 'Identity provider',
    infrastructure: 'Infrastructure',
    instanceType: 'Instance type',
    bucket: 'Bucket',
    warehouse: 'Warehouse',
    connection: 'Connection',
    endpoint: 'Endpoint',
    workspace: 'Workspace',
    session: 'Session',
    stream: 'Stream',
    bridge: 'Bridge',
    device: 'Device',
    runtime: 'Runtime',
    runtimeVersion: 'Runtime version',
    runtimeBuild: 'Build',
    firewallRule: 'Firewall rule',
    ticket: 'Ticket',
    graph: 'Graph',
    glossaryTerm: 'Glossary term',
    llmModel: 'Language model',
    llmProvider: 'LLM provider',
    ragIndex: 'Assistant',
    agentPolicy: 'Agent policy',
    approval: 'Approval',
    model: 'Model',
    experiment: 'Experiment',
    experimentRun: 'Experiment run',
  },
};
